import ProgressBar from "components/core/basic/ProgressBar";
import { useFetch } from "hooks/api";
import { useMemo } from "react";
import { Col, Row } from "react-bootstrap";

interface Props {
  showLabel?: boolean;
}

interface WorkflowItem {
  is_finished: boolean;
  id: string;
  created_at: string;
  updated_at: string;
  tracking_id: string;
  status: string;
}

interface WorkflowResponse {
  data?: {
    results?: WorkflowItem[];
  };
}

interface WorkflowDetails {
  data?: {
    progress: [number, number];
  };
}

const OnboardingWorkflowProgress = ({ showLabel = true }: Props) => {
  const workflows = useFetch<WorkflowResponse>(["workflows"], "/api/workflow", {}, {});

  const onboardingWorkflowId = useMemo(() => {
    return workflows.data?.data?.results
      ?.filter((workflow: WorkflowItem) => workflow.status === "PENDING" && workflow.id.includes("onboarding"))
      .sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())[0]?.tracking_id;
  }, [workflows.data]);

  const onboardingWorkflowProgress = useFetch<WorkflowDetails>(
    ["onboardingWorkflow", onboardingWorkflowId],
    `/api/workflows/${onboardingWorkflowId}/progress/`,
    {},
    {
      enabled: !!onboardingWorkflowId,
      // Refetch every 10s
      refetchInterval: 1000 * 10,
    },
  );

  const [completedTaskCount, totalTaskCount] = onboardingWorkflowProgress.data?.data?.progress ?? [];
  const percentCompleted = completedTaskCount && totalTaskCount ? completedTaskCount / totalTaskCount : 0;

  if (!onboardingWorkflowId || onboardingWorkflowProgress.isLoading || isNaN(percentCompleted)) {
    return;
  }

  return (
    <Row className="pb-4">
      <Col className="d-flex flex-column justify-content-center align-items-center p-3 fs-standard w-100">
        {showLabel && <span className="mb-3">Trellis is importing your historical data</span>}
        <ProgressBar
          progress={percentCompleted * 100}
          label={<small className="d-block pt-3">{Math.round(percentCompleted * 100)}% complete</small>}
          width={"350px"}
          height={"16px"}
        />
      </Col>
    </Row>
  );
};

export default OnboardingWorkflowProgress;
